module.exports = __webpack_public_path__ + "img/atl-chevron-left.1510072a.svg";